export const physicalCardsConstants = {
  SET_PHYSICAL_CARDS_LOADING: 'physicalCards/SET_PHYSICAL_CARDS_LOADING',
  GET_PHYSICAL_CARDS: 'physicalCards/GET_PHYSICAL_CARDS',
  SEARCH_PHYSICAL_CARDS: 'physicalCards/SEARCH_PHYSICAL_CARDS',
  SET_PHYSICAL_CARDS: 'physicalCards/SET_PHYSICAL_CARDS',
  CLEAR_PHYSICAL_CARDS: 'physicalCards/CLEAR_PHYSICAL_CARDS',
  ADD_PHYSICAL_CARD: 'physicalCards/ADD_PHYSICAL_CARD',
  GET_PHYSICAL_CARD: 'physicalCards/GET_PHYSICAL_CARD',
  SET_PHYSICAL_CARD: 'physicalCards/SET_PHYSICAL_CARD',
  CLEAR_PHYSICAL_CARD: 'physicalCards/CLEAR_PHYSICAL_CARD',
  UPDATE_PHYSICAL_CARD: 'physicalCards/UPDATE_PHYSICAL_CARD',
  ADD_PHYSICAL_CARD_DISCOUNT: 'physicalCards/ADD_PHYSICAL_CARD_DISCOUNT',
  SET_PHYSICAL_CARD_DISCOUNT_ERROR:
    'physicalCards/SET_PHYSICAL_CARD_DISCOUNT_ERROR',
  CLEAR_PHYSICAL_CARD_DISCOUNT_ERROR:
    'physicalCards/CLEAR_PHYSICAL_CARD_DISCOUNT_ERROR',
  TOP_UP_PHYSICAL_CARD: 'physicalCards/TOP_UP_PHYSICAL_CARD',
  GET_PHYSICAL_CARD_USAGE: 'physicalCards/GET_PHYSICAL_CARD_USAGE',
  SET_PHYSICAL_CARD_USAGE: 'physicalCards/SET_PHYSICAL_CARD_USAGE',
  CLEAR_PHYSICAL_CARD_USAGE: 'physicalCards/CLEAR_PHYSICAL_CARD_USAGE',
  DOWNLOAD_PHYSICAL_CARDS_IMPORT_TEMPLATE:
    'physicalCards/DOWNLOAD_PHYSICAL_CARDS_IMPORT_TEMPLATE',
  SET_PHYSICAL_CARDS_TEMPLATE_DOWNLOADING:
    'physicalCards/SET_PHYSICAL_CARDS_TEMPLATE_DOWNLOADING',
  VALIDATE_PHYSICAL_CARDS_IMPORT:
    'physicalCards/VALIDATE_PHYSICAL_CARDS_IMPORT',
  SET_PHYSICAL_CARDS_IMPORT_VALIDATING:
    'physicalCards/SET_PHYSICAL_CARDS_IMPORT_VALIDATING',
  SET_PHYSICAL_CARDS_IMPORT_BATCH:
    'physicalCards/SET_PHYSICAL_CARDS_IMPORT_BATCH',
  CLEAR_PHYSICAL_CARDS_IMPORT: 'physicalCards/CLEAR_PHYSICAL_CARDS_IMPORT',
  COMMIT_PHYSICAL_CARDS_IMPORT: 'physicalCards/COMMIT_PHYSICAL_CARDS_IMPORT',
  SET_PHYSICAL_CARDS_IMPORT_COMMITTING:
    'physicalCards/SET_PHYSICAL_CARDS_IMPORT_COMMITTING',
  SET_PHYSICAL_CARDS_IMPORT_COMMIT_RESULT:
    'physicalCards/SET_PHYSICAL_CARDS_IMPORT_COMMIT_RESULT',
  DOWNLOAD_PHYSICAL_CARDS_IMPORT_FAILED_ROWS:
    'physicalCards/DOWNLOAD_PHYSICAL_CARDS_IMPORT_FAILED_ROWS',
};
